import CestModel from "../../models/produto/cestModel";
import { iServiceCached } from "../base/iServiceCached";

class CestService extends iServiceCached<CestModel> {
    constructor() {
        super("Cest");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.codigo + " - " + p.descricao,
        }));
    }
}

export default new CestService();
